// src/api/serviceRequestsApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchServiceRequests = async () => {
  const res = await apiClient.get(`/service-requests/get_all`, getAuthHeader());
  const list = res.data?.data || [];

  try {
    const user = JSON.parse(localStorage.getItem("user")) || {};

    if (user.role === "admin") return list;

    if (user.role === "firm") {
      return list.filter(r => String(r.user_id) === String(user.id));
    }
    if (user.role === "lawyer") {
      return list.filter(r => {
        if (!r.lawyer_ids) return false;
        const ids = r.lawyer_ids.split(",").map(id => id.trim());
        return ids.includes(String(user.id));
      });
    }
    if (user.role === "team") {
      return list.filter(r => {
        if (!r.team_ids) return false;
        const ids = r.team_ids.split(",").map(id => id.trim());
        return ids.includes(String(user.id));
      });
    }
    return list.filter(r => String(r.user_id) === String(user.id));

  } catch {
    return list;
  }
};
export const createServiceRequest = async (payload) => {
  return apiClient.post(`/service-requests/create`, payload, getAuthHeader());
};
export const updateServiceRequest = async (id, payload) => {
  return apiClient.post(`/service-requests/update/${id}`, payload, getAuthHeader());
};
export const deleteServiceRequest = async (id) => {
  return apiClient.delete(`/service-requests/delete/${id}`, getAuthHeader());
};
export const updateServiceRequestStatus = async (id, status) => {
  return apiClient.post(
    `/service-requests/updateStatus/${id}`,
    { status },
    getAuthHeader()
  );
};
